module.exports = __webpack_public_path__ + "img/50m4.00e9d21e.jpg";